"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IrisApiEngineImpl = exports.IrisEventHandlerImpl = void 0;
const IrisApiEngine_1 = require("./IrisApiEngine");
const IrisEventHandlerManagerImpl_1 = require("./IrisEventHandlerManagerImpl");
const DO_NOT_HANDLE = -10000;
class IrisEventHandlerImpl {
    static create(eventHandler) {
        let id = IrisEventHandlerImpl.nextEventId++;
        return new IrisEventHandlerImpl(id, eventHandler);
    }
    constructor(id, eventHandler) {
        this.eventId = id;
        this._eventHandler = eventHandler;
    }
    onEvent(param) {
        param.eventHandle = this.eventId.toString();
        let newParam = new IrisApiEngine_1.IrisCore.EventParam(param.event, param.data, param.data_size, param.result, param.buffer, param.length, param.buffer_count, this.eventId.toString());
        if (this._eventHandler) {
            this._eventHandler(newParam);
        }
    }
}
exports.IrisEventHandlerImpl = IrisEventHandlerImpl;
IrisEventHandlerImpl.nextEventId = 1;
class IrisApiEngineImpl {
    constructor() {
        this.apiInterceptors = [];
        this.irisEventHandlerManager = new IrisEventHandlerManagerImpl_1.IrisEventHandlerManagerImpl();
    }
    getIrisEventHandlerManager() {
        return this.irisEventHandlerManager;
    }
    // static getInstance() {
    //     if (!IrisApiEngine.instance) {
    //         IrisApiEngine.instance = new IrisApiEngine();
    //     }
    //     return IrisApiEngine.instance;
    // }
    addApiInterceptor(interceptor) {
        let item = this.apiInterceptors.find((value) => {
            return value === interceptor;
        });
        if (!item) {
            this.apiInterceptors.push(interceptor);
        }
    }
    removeApiInterceptor(interceptor) {
        this.apiInterceptors.forEach((item, index) => {
            if (item === interceptor)
                this.apiInterceptors.splice(index, 1);
        });
    }
    callIrisApi(apiParam) {
        for (let interceptor of this.apiInterceptors) {
            let result = interceptor.intercept(apiParam);
            if (result) {
                return result;
            }
        }
        return Promise.resolve(IrisApiEngine_1.CallIrisApiResult.failed(DO_NOT_HANDLE, 0));
    }
    dispose() {
        this.apiInterceptors = [];
        return Promise.resolve();
    }
}
exports.IrisApiEngineImpl = IrisApiEngineImpl;
